import React from 'react';
import styled from 'styled-components';

const defaultStyle = {
    primaryColor: 'var(--primary-accent2-color)',
    margin: 0,
    width: 'fit-content'
}

const Container = styled.div`
    background-color: ${props => props.styles.primaryColor};
    /* border: ${props => `1px solid ${props.styles.primaryColor}`}; */
    border-radius: 5px;
    width: ${props => props.styles.width};
    height: 'fit-content';
    margin: ${props => props.styles.margin};
    box-shadow: ${props => `0px 2px 1px -1px ${props.styles.primaryColor},` + 
                        `0px 1px 1px 0px ${props.styles.primaryColor}, ` +
                        `0px 1px 3px 0px ${props.styles.primaryColor}`};
    :hover {
        box-shadow: ${props => props.hover ? 'rgba(0, 0, 0, 0.24) 0px 3px 8px' : null};
    };
`

const Paper = props => {
    const {
        style,
        hover
    } = props;

    let updatedStyle = Object.assign({}, defaultStyle, style)
    return (
        <Container styles={updatedStyle} hover={hover}>
            {props.children ? props.children : null}
        </Container>
    )
}

export default Paper;